import { useState } from "react";
import "../style/exam-result/ER_ResultTable.css";

const ER_ResultTable = () => {
  //exam data-------------------------------------------------------------------
  const [data] = useState([
    {
      id: 1,
      name: "ریاضی",
      percent: 50,
      level: 4000,
      average_percent: 20,
      max_percent: 100,
      min_percent: -10,
      max_level: 5000,
      min_level: 1000,
      rank: 100,
    },
    {
      id: 2,
      name: "فلسفه",
      percent: 80,
      level: 4800,
      average_percent: 5,
      max_percent: 100,
      min_percent: -10,
      max_level: 5000,
      min_level: 1000,
      rank: 100,
    },
    {
      id: 3,
      name: "منطق",
      percent: 70,
      level: 4500,
      average_percent: 10,
      max_percent: 100,
      min_percent: -10,
      max_level: 5000,
      min_level: 1000,
      rank: 10,
    },
    {
      id: 4,
      name: "مبانی موسیقی",
      percent: 60,
      level: 4500,
      average_percent: 10,
      max_percent: 100,
      min_percent: -10,
      max_level: 5000,
      min_level: 1000,
      rank: 10,
    },
    {
      id: 5,
      name: "برنامه نویسی",
      percent: 70,
      level: 4500,
      average_percent: 10,
      max_percent: 100,
      min_percent: -10,
      max_level: 5000,
      min_level: 1000,
      rank: 10,
    },
  ]);

  return (
    <div className="er-result-table">
      {/* //---title-row--------------------------------------------------------- */}
      <div className="er-result-table-title-row">
        <div className="er-result-table-title-row-item">ردیف</div>
        <div className="er-result-table-title-row-item">نام درس</div>
        <div className="er-result-table-title-row-item">درصد</div>
        <div className="er-result-table-title-row-item">تراز</div>
        <div className="er-result-table-title-row-item">میانگین درصد</div>
        <div className="er-result-table-title-row-item">بالاترین درصد</div>
        <div className="er-result-table-title-row-item">پایین‌ترین درصد</div>
        <div className="er-result-table-title-row-item">بالاترین تراز</div>
        <div className="er-result-table-title-row-item">پایین‌ترین تراز</div>
        <div className="er-result-table-title-row-item">رتبه</div>
      </div>
      {/* //---item-row--------------------------------------------------------- */}
      {data.map((item, index) => (
        <div key={item.id} className="r-result-table-item-row">
          <div className="er-result-table-item-row-item">{index + 1}</div>
          <div className="er-result-table-item-row-item">{item.name}</div>
          <div className="er-result-table-item-row-item">{item.percent}</div>
          <div className="er-result-table-item-row-item">{item.level}</div>
          <div className="er-result-table-item-row-item">
            {item.average_percent}
          </div>
          <div className="er-result-table-item-row-item">
            {item.max_percent}
          </div>
          <div className="er-result-table-item-row-item">
            {item.min_percent}
          </div>
          <div className="er-result-table-item-row-item">{item.max_level}</div>
          <div className="er-result-table-item-row-item">{item.min_level}</div>
          <div className="er-result-table-item-row-item">{item.rank}</div>
        </div>
      ))}
    </div>
  );
};

export default ER_ResultTable;
